import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import withStyles from '@mui/styles/withStyles';

import { Button, Divider, Accordion, AccordionSummary, AccordionDetails, Grid, List, ListItem, ListItemIcon, ListItemText, Typography
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Add, Cloud, CreditCard, People} from '@mui/icons-material';

import PageTitle from '../ui/PageTitle';

const styleSheet = theme => ({
  button: {
    margin: theme.spacing(1),
  },
});
  
class Help extends Component {
  
  showTour = () => {
    //this.props.history.push(`/home?_up_exp=1576074749bGxr2339`);
    //window.location.reload();
    console.log(this.props.menuState);
    if( window.innerWidth < 600 && !this.props.menuState ) {
      //assume mobile tour
      window.location.href = `/home?_up_exp=1576268912zQev3293`;
    } else {
      window.location.href = `/home?_up_exp=1576074749bGxr2339`;
    }

  }
  showFundingTour = () => {
    //this.props.history.push(`/fundingsources?_up_exp=1576003644dUlj0764`);
    //window.location.reload();
    window.location.href = `/fundingsources?_up_exp=1576003644dUlj0764`;
  }
  showAddCustomerTour = () => {
    //this.props.history.push(`/customers?_up_exp=1576006380aVuz7075`);
    //window.location.reload();
    window.location.href = `/customers?_up_exp=1576006380aVuz7075`;
  }
  showSubscriptionTour = () => {
    //this.props.history.push(`/subscriptioncreate?_up_exp=1575903826qLcd9466`);
    //window.location.reload();
    window.location.href = `/subscriptioncreate?_up_exp=1575903826qLcd9466`;
  }

  render() {
    const { isAuthenticated, needAssent } = this.props.auth;
    const { classes } = this.props;
    return (
      <div>
        {
          isAuthenticated() && !needAssent() && (
            <div>
              <PageTitle title="Help" subtitle="What can I do with AppBind?"/>


              <Grid container spacing={3} direction="row" justifyContent="flex-start">
  

                <Grid item  xs={12} xl={11} style={{marginTop: 24}}>

                {(!this.props.auth.isUnauthenticatedCustomer()) && (
                  <Accordion>

                    <AccordionSummary aria-controls="get-started-content" id="get-started" expandIcon={<ExpandMoreIcon />}>                     
                      <Typography variant="h6"> Get started </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={3} direction="row" justifyContent="flex-start">

                        <Grid item xs={12}>
                          <Divider style={{marginTop: -20}}/>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <Grid item xs={12}>
                              <Typography  variant="h6">Steps</Typography>
                          </Grid>
                          <Grid item xs={12}>
                              <List >
                                  <ListItem>
                                    <ListItemIcon>
                                      <CreditCard />
                                    </ListItemIcon>
                                    <ListItemText primary="Create your funding source."/>
                                  </ListItem>
                                  <ListItem>
                                      <ListItemIcon>
                                        <Add />
                                      </ListItemIcon>
                                      <ListItemText primary="Buy a subscription for yourself." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <People />
                                     </ListItemIcon>
                                     <ListItemText primary="Add a customer and invite them to enter their funding source." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <Add />
                                     </ListItemIcon>
                                     <ListItemText primary="Buy a subscription for your customer." />
                                  </ListItem>
                              </List>
                            </Grid>                        
                        </Grid>

                        {/*<Grid item xs={6}>
                          <Typography className={classes.heading}> Video Placeholder </Typography>
                        </Grid>*/}
                        <Grid item xs={12}>
                          <Button  color="primary" variant="contained"
                              className={classes.button}
                              onClick={this.showTour}>
                            Guide me in app
                          </Button>
                        </Grid>

                      </Grid>
                      </AccordionDetails>
                  </Accordion>
                  )}

                  <Accordion style={{marginTop: 16}}>

                    <AccordionSummary aria-controls="add-funding-source-content" id="funding-source" expandIcon={<ExpandMoreIcon />}>                     
                      <Typography  variant="h6"> Add a funding source </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={3} direction="row" justifyContent="flex-start">

                        <Grid item xs={12}>
                          <Divider style={{marginTop: -20}}/>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography style={{marginTop: -28}} variant="body1">
                            When you add a funding source, you're giving AppBind authorization to bill your credit card 
                            (credit card funding sources) or bank account (ACH funding sources) to pay for subscriptions
                            purchased with AppBind.  Once billing is initiated in AppBind (credit card charge or ACH bank
                            transfer), it cannot be cancelled within AppBind, as it is billing for a subscription payment 
                            that has already been made on your behalf.  If you have any questions about a billing transaction 
                            on your credit card or bank account, please contact AppBind support at support@appbind.com.
                          </Typography>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                          <Grid item xs={12}>
                              <Typography  variant="h6">Steps</Typography>
                          </Grid>
                          <Grid item xs={12}>
                              <List >
                                  <ListItem>
                                    <ListItemIcon>
                                      <CreditCard />
                                    </ListItemIcon>
                                    <ListItemText primary="Select my funding."/>
                                  </ListItem>
                                  <ListItem>
                                      <ListItemIcon>
                                        <Add />
                                      </ListItemIcon>
                                      <ListItemText primary="Click on appropriate add button." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <ImportExportIcon />
                                     </ListItemIcon>
                                     <ListItemText primary="If necessary, reorder their priority." />
                                  </ListItem>
                              </List>
                            </Grid>
                        </Grid>

                        {/*<Grid item xs={6}>
                          <Typography className={classes.heading}> Video Placeholder </Typography>
                        </Grid>*/}
                        <Grid item xs={12}>
                          <Button  color="primary" variant="contained"
                              className={classes.button}
                              onClick={this.showFundingTour}>
                            Guide me in app
                          </Button>
                        </Grid>

                      </Grid>
                    </AccordionDetails>
                  </Accordion>


                  {(!this.props.auth.isUnauthenticatedCustomer()) && (
                  <Accordion style={{marginTop: 16}}>

                    <AccordionSummary aria-controls="add-customers-content" id="customers" expandIcon={<ExpandMoreIcon />}>                     
                      <Typography  variant="h6"> Add customers </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={3} direction="row" justifyContent="flex-start">

                        <Grid item xs={12}>
                          <Divider style={{marginTop: -20}}/>
                        </Grid>


                        <Grid item xs={12} lg={6}>
                          <Grid item xs={12}>
                              <Typography  variant="h6">Steps</Typography>
                          </Grid>
                          <Grid item xs={12}>
                              <List >
                                  <ListItem>
                                    <ListItemIcon>
                                      <People />
                                    </ListItemIcon>
                                    <ListItemText primary="Select customers."/>
                                  </ListItem>
                                  <ListItem>
                                      <ListItemIcon>
                                        <Add />
                                      </ListItemIcon>
                                      <ListItemText primary="Click on add customer." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <ContactMailIcon />
                                     </ListItemIcon>
                                     <ListItemText primary="Enter all details including primary contact." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <MailOutlineIcon />
                                     </ListItemIcon>
                                     <ListItemText primary="Click save and invite.  Customize email as desired.  Customer will be able to see their own dashboard where they can enter their own funding sources." />
                                  </ListItem>
                              </List>
                            </Grid>
                        </Grid>


                        {/*<Grid item xs={6}>
                          <Typography className={classes.heading}> Video Placeholder </Typography>
                        </Grid>*/}
                        <Grid item xs={12}>
                          <Button  color="primary" variant="contained"
                              className={classes.button}
                              onClick={this.showAddCustomerTour}>
                            Guide me in app
                          </Button>
                        </Grid>

                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  )}

                  {(!this.props.auth.isUnauthenticatedCustomer()) && false && (
                  <Accordion style={{marginTop: 16}}>

                    <AccordionSummary aria-controls="buy-subscription-content" id="buy-subscription" expandIcon={<ExpandMoreIcon />}>                     
                      <Typography  variant="h6"> Buy a subscription </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Grid container spacing={3} direction="row" justifyContent="flex-start">

                       <Grid item xs={12}>
                          <Divider style={{marginTop: -20}}/>
                       </Grid>

                       <Grid item xs={12} lg={6}>
                          <Grid item xs={12}>
                              <Typography  variant="h6">Steps</Typography>
                          </Grid>
                          <Grid item xs={12}>
                              <List >
                                  <ListItem>
                                      <ListItemIcon>
                                        <Add />
                                      </ListItemIcon>
                                      <ListItemText primary="Click on buy subscription." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <People />
                                     </ListItemIcon>
                                     <ListItemText primary="Select your customer or indicate buying for yourself." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <Cloud />
                                     </ListItemIcon>
                                     <ListItemText primary="Select application you are buying." />
                                  </ListItem>
                                  <ListItem>
                                    <ListItemIcon>
                                        <ExitToAppIcon />
                                     </ListItemIcon>
                                     <ListItemText primary="Confirm and sign up using the newly created card." />
                                  </ListItem>
                              </List>
                            </Grid>
                        </Grid>

                        {/*<Grid item xs={6}>
                          <Typography className={classes.heading}> Video Placeholder </Typography>
                        </Grid>*/}
                        <Grid item xs={12}>
                          <Button  color="primary" variant="contained"
                              className={classes.button}
                              onClick={this.showSubscriptionTour}>
                            Guide me in app
                          </Button>
                        </Grid>

                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  )}

 
                </Grid>

               </Grid>



            </div>
          )
        }
        {
          (!isAuthenticated() || needAssent()) && (
            <Redirect to='/home' />
          )
        }
      </div>
    );
  }

}

export default withStyles(styleSheet)(Help);

